import { useMemo } from 'react';
import { type PermissionSupplier } from '../../product-router/product/check-product-permissions';
import { BitbucketScope } from './types';
import { getUserWorkspaces, getFirstBitbucketWorkspaceId } from './get-user-workspaces';

/**
 * Bitbucket permission supplier that uses the /user/workspaces API instead of the scopes API.
 * Repository search requires Bitbucket workspace context.
 * Permission is granted only when the user has access to at least one workspace with a valid uuid.
 */
export const useBitbucketWorkspacesPermissionSupplier = (
	overridenPermissionsSupplier?: PermissionSupplier,
) => {
	return useMemo(() => {
		if (overridenPermissionsSupplier) {
			return overridenPermissionsSupplier;
		}

		return (): Promise<string[]> =>
			getUserWorkspaces()
				.then((response) =>
					getFirstBitbucketWorkspaceId(response).length > 0
						? [BitbucketScope.BitbucketRepostitory]
						: [],
				)
				.catch(() => []);
	}, [overridenPermissionsSupplier]);
};
